import * as React from 'react';
import ReactTable from 'react-table';
import TimeStampPanel from '../panels/timestampPanel';
import axios,  { AxiosRequestConfig, AxiosResponse } from 'axios';

interface TraceRouteItem {
    ip: string;
    usec: number;
    host: string;
}

class State {
    data: Array<any>;
    tracerouteData: Array<TraceRouteItem>;
    ts?: number;
    firstTime?: boolean;
    selected?: number;
}

interface Props {
    refresh?: number;
    streamid: number;
    streamName: string;
    url: string;
    meta?: string;
    timerange?: string;
    summary?: boolean;
}

export default class TraceRouteView extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        meta: 'traceroute',
        timerange: 'all',
        summary: false,
        refresh: 10000
    };
    private updateTimer: number;
    componentWillMount() {
        this.setState({
            ts: 0,
            firstTime: true,
            selected: 0
        });
    }
    componentDidMount() {
        this.fetchData();
    }
    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
    }

    content() {
        // tslint:disable-next-line:no-empty
        if (this.state == null || this.state.data == null || this.state.selected == null) {
        } else {
            if (this.state.data[ this.state.selected] && this.state.data[ this.state.selected].route) {
                this.setState({
                    tracerouteData: this.state.data[this.state.selected].route
                });
            }
        }
    }
    render() {
        const traceRouteGridColumns = [{
            Header: 'IP Address',
            width: 300,
            accessor: 'ip',
            resizable: false
        }, {
            Header: 'time (ms)',
            width: 130,
            accessor: 'usec',
            resizable: false,
            Cell: (props: any) => this.timeRenderer(props.value),
        }, {
            Header: 'Host',
            width: 300,
            accessor: 'host',
            resizable: false
        }];

        return (
            <div className="view-content" id="assets">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Traceroute</div>
                        </div>
                    </div>
                </div>
                <div className="manifestWindowTBar" title={this.props.url}>
                    <h4>{this.props.streamName}</h4>
                    <h5>{this.props.url}</h5>
                </div>
                <div className="dividedArea">
                    <div className="fixedWidth">
                        <TimeStampPanel
                            ref="assets"
                            header="Timestamp"
                            className="timestamp-panel-mediaFile"
                            data={(this.state && this.state.data) ? this.state.data : []}
                            activeTs={this.state.ts}
                            onClick={(ts: number, i: number) => {
                                this.setState({
                                    ts: ts,
                                    selected: i
                                },            () => this.content());
                            }}
                        />
                    </div>
                    <ReactTable
                        className="calculatedWidth content-bg transaction-log -striped -highlight"
                        data={(this.state && this.state.tracerouteData) ? this.state.tracerouteData : []}
                        columns={traceRouteGridColumns}
                        showPagination={false}
                        pageSize={this.state.tracerouteData && this.state.tracerouteData.length > 20 ? this.state.tracerouteData.length : 20}
                    />
                </div>
            </div>
        );
    }

    scheduleNextUpdate(ms ?: number) {
        if (ms === undefined)
            ms = this.props.refresh;
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }
    timeRenderer(props: any) {
        if (props) {
            const msec = props / 1000;
            return msec.toFixed(3);
        }
        return '';
    }
    fetchData() {
        let _this = this;
        let url = 'http://default/api/metadata';
        axios.post(url, {
            meta: this.props.meta,
            streams: this.props.streamid,
            timerange: this.props.timerange,
            summary: this.props.summary
        },         {
            headers: {
                'x-orderby': 'order routes by timestamp desc'
            }
        })
            .then(function (response: AxiosResponse) {
                if ( response.data !== undefined  ) {
                    if (response.data.routes !== undefined) {
                        const index = response.data.routes.findIndex(function(element: any) {
                            return element.timestamp === _this.state.ts;
                        });

                        if (index === -1) {
                            if (_this.state.firstTime) {
                                _this.setState ( {
                                    firstTime: false
                                });
                            }
                            _this.setState ( {
                                ts: response.data.routes[0].timestamp,
                                data: response.data.routes,
                                selected: 0
                            },               () => _this.content());
                        } else {
                            _this.setState({
                                data: response.data.routes,
                                selected: index
                            },             () => _this.content());
                        }
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of manifests, got ', response.data);
                } else {
                    // tslint:disable-next-line:no-console
                    console.log(' manifests request error: ', response.data);
                }
                _this.scheduleNextUpdate();
            })
            .catch(function (error: AxiosRequestConfig) {
                _this.scheduleNextUpdate();
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/traceroute.tsx